import { jsx as n } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { Link as s } from "@mui/material";
import { forwardRef as l } from "react";
const f = l((t, m) => {
  const o = p(7);
  let r, i;
  o[0] !== t ? ({
    children: r,
    ...i
  } = t, o[0] = t, o[1] = r, o[2] = i) : (r = o[1], i = o[2]);
  let e;
  return o[3] !== r || o[4] !== i || o[5] !== m ? (e = /* @__PURE__ */ n(s, { ref: m, ...i, children: r }), o[3] = r, o[4] = i, o[5] = m, o[6] = e) : e = o[6], e;
});
f.displayName = "Link";
export {
  f as Link
};
